"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const formik_1 = require("formik");
const moment_1 = tslib_1.__importDefault(require("moment"));
const react_1 = tslib_1.__importDefault(require("react"));
const react_datetime_1 = tslib_1.__importDefault(require("react-datetime"));
const react_select_1 = tslib_1.__importDefault(require("react-select"));
const reactstrap_1 = require("reactstrap");
exports.FormGroup = formik_1.connect((props) => {
    const { name, mutationResult, type, label, disabled, loading, rows, placeholder, formik, hideLabel, autoComplete, autoCorrect, spellCheck, } = props;
    const { errors, touched, setFieldValue, values } = formik;
    const hasErrors = mutationResult &&
        mutationResult.error &&
        mutationResult.error.graphQLErrors &&
        mutationResult.error.graphQLErrors.length > 0;
    let validationErrors = [];
    if (hasErrors) {
        validationErrors = mutationResult.error.graphQLErrors
            .filter(graphQLErrors => {
            return (graphQLErrors.validationErrors &&
                graphQLErrors.validationErrors.length > 0);
        })
            .reduce((accum, graphQLError) => {
            return [accum, ...graphQLError.validationErrors];
        }, [])
            .filter(vEs => {
            return vEs && vEs.property === name;
        });
    }
    const newPlaceholder = placeholder || (typeof label === 'string' ? label : '');
    let input;
    if (type === 'select') {
        const options = props.options;
        input = (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_select_1.default, Object.assign({ isDisabled: disabled, placeholder: newPlaceholder, name: name, options: options, value: values[name] || undefined, className: "react-select-container", classNamePrefix: "react-select", menuPlacement: "auto" }, props.selectProps, { onChange: (option, action) => {
                    setFieldValue(name, option);
                    if (props.selectProps.onChange) {
                        setTimeout(() => {
                            props.selectProps.onChange(option, action);
                        }, 1);
                    }
                } }))));
    }
    else if (type === 'querySelect') {
        input = react_1.default.createElement(react_1.default.Fragment, null, "Foo");
        // input = <OsmosysResourceSelectBox resource="emailList" />;
        // input = (
        // //   <OsmosysResourceSelectBox
        // //     isDisabled={disabled}
        // //     placeholder={newPlaceholder}
        // //     name={name}
        // //     value={values[name] || undefined}
        // //     {...props.querySelectProps}
        // //     onChange={(option: IOption, action) => {
        // //       setFieldValue(name, option);
        // //       if (props.querySelectProps.onChange) {
        // //         setTimeout(() => {
        // //           props.querySelectProps.onChange(option, action);
        // //         }, 1);
        // //       }
        // //     }}
        // //   />
        // );
    }
    else if (type === 'datetime' || type === 'time' || type === 'date') {
        input = (react_1.default.createElement(react_datetime_1.default, Object.assign({ inputProps: {
                disabled,
                name,
                placeholder: placeholder || (typeof label === 'string' ? label : ''),
            }, value: values[name], onChange: dt => {
                const momentDt = moment_1.default(dt);
                if (type === 'time') {
                    setFieldValue(name, moment_1.default().set({
                        hour: momentDt.hour(),
                        minutes: momentDt.minutes(),
                    }));
                }
                else {
                    setFieldValue(name, momentDt);
                }
            }, dateFormat: type === 'time' ? false : undefined }, props.datetimeProps)));
    }
    else if (type === 'checkbox') {
        input = (react_1.default.createElement(reactstrap_1.CustomInput, { onChange: e => {
                setFieldValue(name, e.target.checked);
                return e.target.checked;
            }, value: values[name], type: "switch", 
            // label={label}
            name: name, title: placeholder, disabled: disabled, id: `form-${type}-${name}`, className: props.inputClassName, checked: type === 'checkbox' ? values[name] : undefined, bsSize: "lg" }));
    }
    else {
        input = (react_1.default.createElement(reactstrap_1.Input, { disabled: disabled, tag: formik_1.Field, placeholder: newPlaceholder, name: name, rows: rows, type: type, min: props.min, max: props.max, component: type === 'textarea' ? type : undefined, className: props.inputClassName, autoComplete: autoComplete, autoCorrect: autoCorrect, spellCheck: spellCheck }));
    }
    if (props.customInput) {
        input = props.customInput;
    }
    const l = (react_1.default.createElement(reactstrap_1.Collapse, { isOpen: true },
        react_1.default.createElement(reactstrap_1.Label, { className: "font-weight-bold" },
            label,
            ' ',
            loading && (react_1.default.createElement("small", { className: "ml-1 text-success" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faSpinnerThird, spin: true }))),
            validationErrors.length > 0 && (react_1.default.createElement("span", { className: "ml-1 text-danger" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faExclamationTriangle }))))));
    const showLabel = hideLabel !== true;
    return (react_1.default.createElement(reactstrap_1.FormGroup, { id: `${name}-form-group`, className: classnames_1.default('clearfix', {
            'mb-2': type === 'checkbox',
        }, props.className), check: type === 'checkbox' },
        showLabel && type !== 'checkbox' && l,
        input,
        showLabel && type === 'checkbox' && l,
        react_1.default.createElement(reactstrap_1.Collapse, { className: "form-error", tag: reactstrap_1.FormText, color: "danger", isOpen: errors[name] && !!touched[name] }, errors[name] ? `${errors[name]}` : '')));
});
// export const FormGroup = connect((props: IProps) => (
//   <FormGroupClass {...props} />
// ));
//# sourceMappingURL=FormGroup.js.map